import Rule from "../../../../../common/rule";
import DriveEndType from "../../../../enums/drive-end-type";
import FootballState from "../../../../state/football-state";

export default class FieldChange extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            [FootballState.Punt, FootballState.CflKick].some(
                (state) => state === fragment.associatedState
            ) &&
            ![
                FootballState.Returned,
                FootballState.TouchBack,
                FootballState.NoRecoveryKickReturn,
                FootballState.KickRecovered
            ].some((state) =>
                play
                    .getFragmentsBetween(fragment, [FootballState.CflKick])
                    .some(({ associatedState }) => associatedState === state)
            )
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { driveTeamId } = gameContext.driveContext;
        const triggerDrive =
            !driveTeamId || fragment.puntedBy.teamId === driveTeamId;
        gameContext.setFieldPosition(fragment.puntedTo);
        ruleContext.setAwardFirstDown(triggerDrive);
        gameContext.switchPossession();
        gameContext.setDriveContext({
            triggerDrive,
            previousDriveEndType: DriveEndType.Punt
        });

        return [];
    }
}
